<template>
  <div id="app" v-loading="$store.state.loading">
    <router-view v-if="ready" :key="$route.name" />

    <div v-if="showNavToMobileBox" class="el-message-box__wrapper navToMobileBox">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title"><span>{{ l("提示") }}</span></div>
          <button type="button" aria-label="Close" class="el-message-box__headerbtn"
            @click="showNavToMobileBox = false">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
              <p>{{ l("当前网页仅支持电脑访问，点击确定前往手机版") }}</p>
            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button type="button" class="
              el-button el-button--default el-button--small el-button--primary
            " @click="goMobile">
            <span> {{ l("确定") }} </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      ready: false,
      showNavToMobileBox: false,
    };
  },
  beforeCreate() {
    console.info(`
██╗    ██╗███████╗██╗      ██████╗ ██████╗ ███╗   ███╗███████╗    ████████╗ ██████╗      ██████╗██╗  ██╗██╗███╗   ██╗ █████╗     ██████╗ ██╗   ██╗ █████╗ ███╗   ██╗ ██████╗ █████╗ ██╗
██║    ██║██╔════╝██║     ██╔════╝██╔═══██╗████╗ ████║██╔════╝    ╚══██╔══╝██╔═══██╗    ██╔════╝██║  ██║██║████╗  ██║██╔══██╗    ██╔══██╗██║   ██║██╔══██╗████╗  ██║██╔════╝██╔══██╗██║
██║ █╗ ██║█████╗  ██║     ██║     ██║   ██║██╔████╔██║█████╗         ██║   ██║   ██║    ██║     ███████║██║██╔██╗ ██║███████║    ██║  ██║██║   ██║███████║██╔██╗ ██║██║     ███████║██║
██║███╗██║██╔══╝  ██║     ██║     ██║   ██║██║╚██╔╝██║██╔══╝         ██║   ██║   ██║    ██║     ██╔══██║██║██║╚██╗██║██╔══██║    ██║  ██║██║   ██║██╔══██║██║╚██╗██║██║     ██╔══██║██║
╚███╔███╔╝███████╗███████╗╚██████╗╚██████╔╝██║ ╚═╝ ██║███████╗       ██║   ╚██████╔╝    ╚██████╗██║  ██║██║██║ ╚████║██║  ██║    ██████╔╝╚██████╔╝██║  ██║██║ ╚████║╚██████╗██║  ██║██║
╚══╝╚══╝ ╚══════╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚══════╝       ╚═╝    ╚═════╝      ╚═════╝╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝╚═╝  ╚═╝    ╚═════╝  ╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝╚═╝  ╚═╝╚═╝
    `);
  },
  created() {
    this.$store.commit("getCategory");
    this.$store.commit("getTags");
    //首次进入网站 有token则获取用户信息
    if (this.$store.state.session.token) {
      this.$store.dispatch("updateSession").then(() => {
        this.$store.commit("updateUnreadNotify");
        this.ready = true; //防止还没拿到权限就进入了某些页面的created回调，因缺少权限而链路出错
        //第一次信用等级异常，会出现提示
        if (this.$store.state.session.tenant && this.$store.state.session.tenant.credit_rating <= 2) {
          const credit_ratingList = this.$store.state.basicInfo.credit_ratingList;
          if (this.$store.state.session.tenant.credit_rating == 0 && this.$localStorage.get("showCreditRatingNotify") != 0) {
            this.$notify({
              dangerouslyUseHTMLString: true,
              message: `<span class="color-danger">【${credit_ratingList[0].tip_title}】</span> ${credit_ratingList[0].tip_content}`,
              duration: 0,
              position: 'bottom-right'
            });
          }
          else if (this.$store.state.session.tenant.credit_rating == 1 && this.$localStorage.get("showCreditRatingNotify") != 1) {
            this.$notify({
              dangerouslyUseHTMLString: true,
              message: `<span class="color-warning">【${credit_ratingList[1].tip_title}】</span> ${credit_ratingList[1].tip_content}`,
              duration: 0,
              position: 'bottom-right'
            });
          }
          else if (this.$store.state.session.tenant.credit_rating == 2 && this.$localStorage.get("showCreditRatingNotify") != 2) {
            this.$notify({
              dangerouslyUseHTMLString: true,
              message: `<span class="color-success">【${credit_ratingList[2].tip_title}】</span> ${credit_ratingList[2].tip_content}`,
              duration: 0,
              position: 'bottom-right'
            });
          }
          this.$localStorage.set("showCreditRatingNotify", this.$store.state.session.tenant.credit_rating);
        }
      });
    } else {
      this.ready = true;
    }
  },
  mounted() {
    //手机访问前往手机下载页
    if (
      navigator.userAgent.match(
        /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
      )
    ) {
      this.showNavToMobileBox = true;
    }
  },
  methods: {
    goMobile() {
      window.location.href = "https://www.chinaduancai.com/down";
    },
  },
};
</script>

<style scoped lang="scss">
.navToMobileBox {
  background: rgba(0, 0, 0, 0.5);

  .el-message-box {
    position: absolute;
    left: 5vw;
    top: 50vh;
    width: 90vw;
    transform: translateY(-50%);
  }
}
</style>

<style lang="scss">
#app {
  // font-family: "Microsoft YaHei", 微软雅黑, "Avenir", "Helvetica Neu", Helvetica,
  //   Arial, sans-serif;
  // font-family: Arial, sans-serif;
  // sans-serif是浏览器可设置的默认字体，写在最后保证其他字体没有时的fallback。
  // windows下中文字体会默认使用微软雅黑，如只是屏幕输出则不涉及版权问题

  font-family: system-ui, -apple-system, "Segoe UI", Roboto, Ubuntu, Cantarell,
    "Noto Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}

body {
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: #333;
  word-break: break-word;
}

// a标签(router-link样式)
a {
  text-decoration: none;
  color: #333;
  display: block;
}

/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 8px; //用于纵向滚动条
  height: 10px; //用于横向滚动条
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(170, 170, 170, 0.9);
  border-radius: 4px;
}

/* loading遮罩 */
// 增大loading遮罩的层级，防止总dialog无法遮盖dialog弹窗
div.el-loading-mask {
  z-index: 9999 !important;
  // background-color: rgba(255, 255, 255, 0.6);
}

/* message遮罩 */
div.el-message-box__wrapper {
  z-index: 99999 !important;
}

/* 页头 */
.PageHeader {
  position: relative;
  padding: 20px;
  background-color: #fbfbfd;
  border-bottom: 1px solid #f0f2f4;

  .el-breadcrumb {
    font-size: 18px;
    line-height: 1;

    .tip {
      font-size: 12px;
      margin-top: 15px;
    }
  }

  .HeaderButtons {
    position: absolute;
    right: 20px;
    top: 10px;

    .el-dropdown+.el-button,
    .el-button+.el-dropdown,
    .el-dropdown+.el-dropdown {
      margin-left: 10px;
    }
  }
}

/* 主体 */
.PageContent {
  padding: 20px;
}

/* 全局el-table样式 */
.el-table th,
.el-table td {
  text-align: center !important;
}

.el-table {
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  box-shadow: none;
}

.el-dropdown+.el-button,
.el-button+.el-button,
.el-button+.el-dropdown,
.el-dropdown+.el-dropdown {
  margin-left: 10px;
}

.el-pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.TableSearchRow {
  padding-top: 15px;
  padding-bottom: 15px;
  align-items: center;

  label {
    display: block;
  }

  label+* {
    margin-top: 10px;
  }

  .el-select {
    width: 100%;
  }

  .el-date-editor {
    width: 100% !important;
  }

  .el-button {
    margin-top: calc(1.2rem + 10px);
  }
}

/* 树组件样式 */
.el-tree-node__content>.el-checkbox {
  margin-right: 9px !important;
}

/* form样式*/
// 用于强制el-form-item标签后的元素换行
.el-form-item {
  .el-select {
    width: 100%;
  }

  .el-input-number {
    width: 100%;
  }

  .el-switch {
    width: 100%;
  }
}

//disabled的input框样式(不能选取readonly的样式，因为elementui中如el-select等也是通过readonly实现的)
.el-input.is-disabled {
  input.el-input__inner {
    // border: none;
    color: #333;
    // cursor: text;
  }

  .el-input__suffix {
    //隐藏下拉箭头
    display: none;
  }
}

.el-textarea.is-disabled {
  textarea.el-textarea__inner {
    color: #333;
  }
}

.el-radio.is-disabled {

  //隐藏未选中的项
  // &:not(.is-checked) {
  //   display: none;
  // }
  //隐藏选中项的勾选框
  // .el-radio__input {
  //   display: none;
  // }
  .el-radio__input.is-disabled+span.el-radio__label {
    //选中项显示为黑色
    color: #333;
  }
}

//el-cascader当checkStrictly=true时，隐藏radio
.el-cascader-panel .el-radio__input {
  visibility: hidden;
}

.color-theme {
  color: $themeColor;
}

.color-primary {
  color: $primaryColor;
}

.color-success {
  color: $successColor;
}

.color-warning {
  color: $warningColor;
}

.color-danger {
  color: $dangerColor;
}

.color-info {
  color: $infoColor;
}

.color-link {
  color: $linkColor;
}

// input:read-only {
//   cursor: default;
// }

//用于面包头图标样式
// i {
//   cursor: default;
// }

//多级下拉框样式
.el-cascader {
  width: 100%;
}

//自动补全框样式
.el-autocomplete {
  width: 100%;
}

//table下拉详情
// .table-expand-form {
//   label {
//     width: 150px;
//     color: #99a9bf;
//   }
//   .el-form-item {
//     margin-right: 0;
//     margin-bottom: 0;
//   }
// }

//淡蓝色高亮link
.ViewLink {
  color: $linkColor;
  cursor: pointer;
  display: inline-block;
  padding-bottom: 1px;
  border-bottom: 1px solid $linkColor;
}

//el-empty中的自定义按钮样式
// .EmptyBtn {
//   border: 1px solid $warningColor;
//   color: $warningColor;
//   width: 96px;
//   height: 32px;
//   line-height: 32px;
//   text-align: center;
//   cursor: pointer;
//   &:hover {
//     background: $warningColor;
//     color: #fff;
//   }
// }

//home页面核心区域宽度
.HomeContainer {
  width: $HomeContainerWidth;
  margin: 0 auto;
  box-sizing: border-box;
  position: relative;
}

//隐藏View时的required星号
.View {

  .el-form-item__label:before,
  .el-form-item__error {
    display: none;
  }
}

//DialogFormData中的子标题
.FormSubTitle {
  font-size: 15px;
  font-weight: bold;
  margin: 15px 0 20px;
  // padding-left: 8px;
  // border-left: 2px solid $warningColor;
}

//APP.vue中不需要/deep/
:disabled {
  &::placeholder {
    /* WebKit browsers */
    color: transparent !important;
  }

  &::-webkit-input-placeholder {
    /* WebKit browsers */
    color: transparent !important;
  }

  &::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: transparent !important;
  }

  &::-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: transparent !important;
  }
}

.one_lines {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1 !important;
  overflow: hidden;
}

.two_lines {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2 !important;
  overflow: hidden;
}

//el-table中的图片样式
.ImageInTable {
  height: 48px; //360浏览器里使用百分比显示异常
  // height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;

  .el-image {
    height: 80%;
    width: 80%;
    top: 10%;
    left: 10%;
    position: absolute;
  }
}

//取消过渡动画
.el-upload-list__item {
  transition: none !important;
}

.el-dialog__header.el-dialog__header {
  .el-dialog__title.el-dialog__title {
    padding-left: 15px;
    position: relative;

    &:before {
      content: "";
      width: 4px;
      position: absolute;
      background: $primaryColor;
      height: 20px;
      top: 2px;
      left: 0;
    }
  }
}

.large-padding-dialog {
  .el-dialog__header.el-dialog__header {
    padding: 30px 35px;

    .el-dialog__headerbtn.el-dialog__headerbtn {
      top: 34px;
      right: 35px;
      font-size: 20px;
    }
  }

  .el-dialog__body.el-dialog__body {
    padding: 10px 100px 0;
  }

  .el-dialog__footer {
    padding: 35px 55px;
  }
}

//限制 show-overflow-tooltip 宽度
.el-tooltip__popper {
  max-width: 1200px;
}
</style>
